import axios from "axios";
import { API_BASE_URL, API_BASE_URL1,API_BASE_URL3 } from "../Services/baseApiUrl";
//const countryId =localStorage.getItem("country_Id");
import axiosInstance from "../../Hooks/axoisInstance";
const getToken = () => {
  return localStorage.getItem("token");
};



export const AllRoles = async () => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `MasterDetails/GetAllRoles`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error;

  }
};


export const AllRolesPermissions = async () => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `MasterDetails/GetAllRolePermissions`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error;

  }
};

export const CreateRoleDetails = async (requestData) => {
  try {
    const response = await axiosInstance.post(
      API_BASE_URL3 + `MasterCreate/AddRolePermissionMapping`,
      requestData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`, // Ensure getToken() is correctly getting the token
          "Content-Type": "application/json" // Add content type if needed
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const getRoleById = async (roleId) => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `MasterDetails/GetAllRolePermissionByRoleId?RoleId=${roleId}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        },

      });
    // console.log(response, 'response')
    return response;
  } catch (error) {
    throw error

  }
};

// export const getRoleById = async (RoleId) => {
//   const token = localStorage.getItem('token');
 
//   try {
//     if (!token) {
//       throw new Error('Token is missing');
//     }
 
//     const response = await axios.post(
//       `${API_BASE_URL1}MasterDetails/GetAllRolePermissionByRoleId`,
//       { roleId: RoleId }, // Pass roleId as part of the request body
//       {
//         headers: {
//           'Content-Type': 'application/json',
//           'Authorization': `Bearer ${token}`,
//         },
//       },
//     );
 
//     console.log('Request headers:', response.config.headers); // Log request headers
 
//     return response.data;
//   } catch (error) {
//     console.error('Error in GetAllRolePermissionByRoleId:', error);
//     throw error;
//   }
// };
 

export const GetRoleDetails = async (ownerTypeData) => {
  try {
    const response = await axiosInstance.put(API_BASE_URL1 + `MasterCreate/UpdateOwnerTypeDetails`, ownerTypeData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error;
    // console.log(error)
  }
};

export const getOwnerTypeById = async (id) => {
  try {
    const response = await axiosInstance.get(API_BASE_URL1 + `owner_type/getById/${id}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        },

      });
    // console.log(response, 'response')
    return response;
  } catch (error) {
    throw error
  }
};
export const UpdateRoles = async (roleId, requestData) => {
  console.log(requestData);
  try {
    const response = await axiosInstance.put(API_BASE_URL3 + `MasterCreate/UpdateRolePermissionMapping/${roleId}`, requestData,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      },
    );
    console.log(response, 'role update')

    
    return response.data;
  } catch (error) {
    throw error;
    // console.log(error)
  }
};